import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import type { UserRole } from '../services/api/TokenManager';
import apiService from '../services/ApiService';

// Route to role mapping
const ROUTE_ROLE_MAP: Record<string, UserRole> = {
  '/manager': 'manager',
  '/operator': 'verificator', // Operator routes are for verificators
  '/multi-camera': 'verificator', // Multi-camera is also for verificators
};

export const useRoleContext = () => {
  const location = useLocation();

  useEffect(() => {
    // Determine role based on current route
    const routeRole = ROUTE_ROLE_MAP[location.pathname];
    
    if (routeRole) {
      // Update the TokenManager to use the appropriate role context
      apiService.setActiveRole(routeRole);
    } else {
      // If we're on a route that doesn't have a specific role (like welcome screen),
      // check if we have a stored role and use it
      const storedRole = sessionStorage.getItem('current_role');
      if (storedRole) {
        apiService.setActiveRole(storedRole as UserRole);
      }
    }
  }, [location.pathname]);

  const currentRole = ROUTE_ROLE_MAP[location.pathname] || null;
  const isManagerRoute = location.pathname === '/manager';
  const isVerificatorRoute = location.pathname === '/operator' || location.pathname === '/multi-camera';

  return {
    currentRole,
    isManagerRoute,
    isVerificatorRoute,
    // Helper to check if the current role has valid tokens
    hasValidTokens: apiService.isAuthenticated(),
  };
};
